import { Injectable, inject } from '@angular/core';
import { Storage, ref, uploadBytes, getDownloadURL } from '@angular/fire/storage';
import { EstadisticasService } from './estadisticas.service';

@Injectable({ providedIn: 'root' })
export class ChatMediaService {
  private storage = inject(Storage);
  private estadisticasService = inject(EstadisticasService);

  /**
   * Sube un archivo multimedia al Storage de Firebase bajo la carpeta 'chats/{chatId}/media'
   * Valida duración sólo para audio (≤ 2 min). La validación de video la maneja el componente.
   * Retorna URL pública y tipo de media.
   */
  async subirMediaChat(
    chatId: string,
    file: File
  ): Promise<{ url: string; tipo: 'image' | 'video' | 'audio' }> {
    const mime = file.type;
    let tipo: 'image' | 'video' | 'audio';

    if (mime.startsWith('image/')) {
      tipo = 'image';
    } else if (mime.startsWith('video/')) {
      tipo = 'video';
    } else if (mime.startsWith('audio/')) {
      tipo = 'audio';
    } else {
      throw new Error('Tipo de archivo no soportado.');
    }

    const timestamp = Date.now();
    const nombre = `${timestamp}_${file.name}`;
    const path = `chats/${chatId}/media/${nombre}`;
    const storageRef = ref(this.storage, path);

    try {
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);
      console.log(`[ChatMediaService] ${tipo} subido correctamente a ${path}`);

      try {
        if (tipo === 'image') {
          await this.estadisticasService.incrementarCampo('totalFotosEnviadas', 1);
        } else if (tipo === 'video') {
          await this.estadisticasService.incrementarCampo('totalVideosEnviados', 1);
        } else if (tipo === 'audio') {
          await this.estadisticasService.incrementarCampo('totalAudiosEnviados', 1);
        }
      } catch (statError) {
        console.error(`[ChatMediaService] Error al actualizar estadísticas para tipo: ${tipo}`, statError);
      }

      return { url, tipo };
    } catch (error) {
      console.error(`[ChatMediaService] Error al subir archivo a ${path}`, error);
      throw new Error('No se pudo subir el archivo multimedia.');
    }
  }
}
